import './Breadcrumbs.scss';

import { PROJECTS, QUESTIONS } from '../../routes/path';
import { t } from 'i18next';
import { useAccount } from '../../contexts/account/AccountContexts';
import React from 'react';

const Breadcrumbs = () => {
  const { projectResponse } = useAccount();

  const path = window.location.pathname;
  const parts = path.split('/').filter(Boolean);

  const getName = (pathPart: string, idx: number) => {
    const id = Number(pathPart);
    if (isNaN(id)) {
      switch (`/${pathPart}`) {
        case PROJECTS:
          return t('projects');

        case QUESTIONS:
          return t('promptsQuestions');

        default:
          return '';
      }
    }

    const previousPart = parts[idx - 1];
    switch (`/${previousPart}`) {
      case PROJECTS:
        const selectedProject = projectResponse?.find((project) => project.id === id);
        const projectLabel = selectedProject?.projectLabel;
        return projectLabel || '';

      default:
        return '';
    }
  };

  const visibleParts = parts
    .map((part, idx) => {
      const name = getName(part, idx) || '';
      return { part, idx, name: name.trim() };
    })
    .filter((item) => item.name !== '');

  if (visibleParts.length === 0) {
    return null;
  }

  return (
    <nav className="breadcrumbs">
      <ul>
        {visibleParts.map(({ idx, name }, i) => {
          const href = '/' + parts.slice(0, idx + 1).join('/');
          const visiblePartsCount = visibleParts.length;
          const isLast = i === visiblePartsCount - 1 && visiblePartsCount > 1;

          return <li key={href}>{isLast ? <span>{name}</span> : <a href={href}>{name}</a>}</li>;
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
